export const ONGOING_CAMPAIGN_EMPTY_STATE_CONTENT = [
  {
    id: 1,
    title: 'Помощь по чат-боту',
    inbox: {
      id: 2,
      name: 'Чат на сайте',
      channel_type: 'Channel::WebWidget',
      phone_number: '',
    },
    sender: {
      id: 1,
      name: 'Александра Рыжова',
    },
    message: 'Здравствуйте! 👋 Нужна помощь с чат-ботом? Спрашивайте!',
    campaign_status: 'active',
    enabled: true,
    campaign_type: 'ongoing',
    trigger_rules: {
      url: 'https://help.vivacrm.ru/chatbot',
      time_on_page: 10,
    },
    trigger_only_during_business_hours: true,
    created_at: '2024-10-24T13:10:26.636Z',
    updated_at: '2024-10-24T13:10:26.636Z',
  },
  {
    id: 2,
    title: 'Поддержка по тарифам',
    inbox: {
      id: 2,
      name: 'Чат на сайте',
      channel_type: 'Channel::WebWidget',
      phone_number: '',
    },
    sender: {
      id: 1,
      name: 'Дмитрий Лебедев',
    },
    message: 'Здравствуйте! 👋 Есть вопросы по тарифам? Готов помочь!',
    campaign_status: 'active',
    enabled: false,
    campaign_type: 'ongoing',
    trigger_rules: {
      url: 'https://help.vivacrm.ru/pricing',
      time_on_page: 10,
    },
    trigger_only_during_business_hours: false,
    created_at: '2024-10-24T13:11:08.763Z',
    updated_at: '2024-10-24T13:11:08.763Z',
  },
  {
    id: 3,
    title: 'Помощь с настройкой',
    inbox: {
      id: 2,
      name: 'Чат на сайте',
      channel_type: 'Channel::WebWidget',
      phone_number: '',
    },
    sender: {
      id: 1,
      name: 'HelpDesk vivaCRM',
    },
    message: 'Привет! Нужна помощь с настройкой? Напишите — подскажу!',
    campaign_status: 'active',
    enabled: false,
    campaign_type: 'ongoing',
    trigger_rules: {
      url: 'https://help.vivacrm.ru/setup',
      time_on_page: 10,
    },
    trigger_only_during_business_hours: false,
    created_at: '2024-10-24T13:11:44.285Z',
    updated_at: '2024-10-24T13:11:44.285Z',
  },
  {
    id: 4,
    title: 'Общая поддержка',
    inbox: {
      id: 2,
      name: 'Чат на сайте',
      channel_type: 'Channel::WebWidget',
      phone_number: '',
    },
    sender: {
      id: 1,
      name: 'Кристина Барлова',
    },
    message:
      'Здравствуйте! 👋 Есть вопросы? Пишите — с радостью помогу!',
    campaign_status: 'active',
    enabled: true,
    campaign_type: 'ongoing',
    trigger_rules: {
      url: 'https://example.ru',
      time_on_page: 200,
    },
    trigger_only_during_business_hours: false,
    created_at: '2024-10-29T19:54:33.741Z',
    updated_at: '2024-10-29T19:56:26.296Z',
  },
];

export const ONE_OFF_CAMPAIGN_EMPTY_STATE_CONTENT = [
  {
    id: 1,
    title: 'Запрос отзыва',
    inbox: {
      id: 6,
      name: 'Чат в приложении',
      channel_type: 'Channel::Sms',
      phone_number: '+79851234567',
      provider: 'default',
    },
    message:
      'Здравствуйте! Понравился сервис? Оставьте отзыв и получите бонус от Т‑Банка: https://help.vivacrm.ru/feedback',
    campaign_status: 'active',
    enabled: true,
    campaign_type: 'one_off',
    scheduled_at: 1729775588,
    audience: [
      { id: 4, type: 'Label' },
      { id: 5, type: 'Label' },
      { id: 6, type: 'Label' },
    ],
    trigger_rules: {},
    trigger_only_during_business_hours: false,
    created_at: '2024-10-24T13:13:08.496Z',
    updated_at: '2024-10-24T13:15:38.698Z',
  },
  {
    id: 2,
    title: 'Приветствие нового клиента',
    inbox: {
      id: 6,
      name: 'Чат в приложении',
      channel_type: 'Channel::Sms',
      phone_number: '+79851234567',
      provider: 'default',
    },
    message: 'Добро пожаловать! 🎉 Если есть вопросы — пишите.',
    campaign_status: 'completed',
    enabled: true,
    campaign_type: 'one_off',
    scheduled_at: 1729732500,
    audience: [
      { id: 1, type: 'Label' },
      { id: 6, type: 'Label' },
      { id: 5, type: 'Label' },
      { id: 2, type: 'Label' },
      { id: 4, type: 'Label' },
    ],
    trigger_rules: {},
    trigger_only_during_business_hours: false,
    created_at: '2024-10-24T13:14:00.168Z',
    updated_at: '2024-10-24T13:15:38.707Z',
  },
  {
    id: 3,
    title: 'Приветствие после записи',
    inbox: {
      id: 6,
      name: 'Чат в приложении',
      channel_type: 'Channel::Sms',
      phone_number: '+79851234567',
      provider: 'default',
    },
    message: 'Здравствуйте! Рады, что вы записались к нам. Ждём на приёме!',
    campaign_status: 'active',
    enabled: true,
    campaign_type: 'one_off',
    scheduled_at: 1730368440,
    audience: [
      { id: 1, type: 'Label' },
      { id: 3, type: 'Label' },
      { id: 6, type: 'Label' },
      { id: 4, type: 'Label' },
      { id: 2, type: 'Label' },
      { id: 5, type: 'Label' },
    ],
    trigger_rules: {},
    trigger_only_during_business_hours: false,
    created_at: '2024-10-30T07:54:49.915Z',
    updated_at: '2024-10-30T07:54:49.915Z',
  },
  {
    id: 4,
    title: 'Онбординг нового оператора',
    inbox: {
      id: 6,
      name: 'Чат в приложении',
      channel_type: 'Channel::Sms',
      phone_number: '+79851234567',
      provider: 'default',
    },
    message: 'Добро пожаловать в команду! Если что-то непонятно — обращайтесь.',
    campaign_status: 'completed',
    enabled: true,
    campaign_type: 'one_off',
    scheduled_at: 1730304840,
    audience: [
      { id: 1, type: 'Label' },
      { id: 3, type: 'Label' },
      { id: 6, type: 'Label' },
    ],
    trigger_rules: {},
    trigger_only_during_business_hours: false,
    created_at: '2024-10-29T16:14:10.374Z',
    updated_at: '2024-10-30T16:15:03.157Z',
  },
];
